import { Grid, InputLabel, MenuItem, FormHelperText, FormControl, Select } from "@mui/material";
import { pink } from "@mui/material/colors";
import { Controller, useFormContext } from "react-hook-form";

const MenuSelect = ({ name, label, size=12, options = [], val='' }) => {
    const { control } = useFormContext();
    if(!options.length) return;
    return(
        <Grid item xs={12} sm={12} md={size}>
            <FormControl fullWidth>
                <InputLabel>{label}</InputLabel>
                <Controller
                    name={name}
                    rules={{ required: 'Valor requerido' }}
                    control={control}
                    defaultValue={val}
                    render = {({
                        field: { onChange, value, onBlur, ref },
                        fieldState: { invalid, error }
                    }) => (<>
                        <Select
                            onBlur={onBlur}
                            onChange={onChange}
                            defaultValue={val}
                            defaultChecked={val}
                            value={value}
                            inputRef={ref}
                            error={invalid}
                            label={label}
                        >
                            <MenuItem value="">Seleciona una opci&oacute;n</MenuItem>
                            { options.map((el, i) => <MenuItem key={i} value={Object.values(el)[0]}>{el.nombre}</MenuItem>) }
                        </Select>
                        <FormHelperText sx={{ color: pink[700] }}>{invalid && error.message}</FormHelperText>
                    </>)}
                />  
            </FormControl>
        </Grid>
    )
}

export default MenuSelect;